module.exports = __webpack_public_path__ + "static/media/opensans-regular.882b6dab.woff";